import { DeviceInfo } from "../../../../domain/models";
import { DeviceInfoEntity } from "../entities";

export default class DeviceInfoMapper {
  static toModel(entity: DeviceInfoEntity): DeviceInfo {
    return new DeviceInfo({
      deviceType: entity.device_type,
    })
  }
}